import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { MeritFault } from '../entities/merit-fault';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';

@Injectable()
export class MeritFaultService extends BaseCrudService<MeritFault> {

    public uri = '/api/meritFault/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance MeritFaultService');
    }

    buildSentence(entity?: MeritFault, event?: LazyLoadEvent): HttpParams {
        this.httpParams = new HttpParams();
        if (entity) {
            let query = '';
            query = query.concat(
                entity.code ?
                `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
                : QueryOperator.Empty
            );
            query = query.concat(
                entity.name ?
                `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
                : QueryOperator.Empty
            );
            if (entity.type && entity.type.id) {
                query = query.concat(
                  `type.id${QueryOperator.Equal}${entity.type.id}${QueryOperator.Split}`
                );
            }
            if (entity.executingUnit && entity.executingUnit.id) {
                query = query.concat(
                  `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
                );
              }
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/merit-fault.service.ts